<div class="row  goods">
  <div class="column shrink left-pan"
       [class.brands-menu-show]="isBrandsMenuShow"
       [class.brands-menu-hide]="!isBrandsMenuShow"
  >
    <div class="cross">
      <a class="close-modal" (click)="closeModal()"></a>
    </div>
    <div class="calculation-card" *ngIf="(!activeOrganization || activeOrganization.type === 'fiz') && !(calcDebt && (calcDebt.summa || calcDebt.summa_nalojki))">
      <a routerLink="/orders_history_new">
        <div class="row">
          <div class="column text-center">
            <span class="alert">Замовлення</span>
          </div>
        </div>
      </a>
    </div>
    <div class="calculation-card-debt" *ngIf="(!activeOrganization || activeOrganization.type === 'fiz') && calcDebt && (calcDebt.summa || calcDebt.summa_nalojki)">
      <a routerLink="/orders_history_new">
        <div *ngIf="calcDebt.summa"
             [class.account]="parseFloat(calcDebt.summa) <= 0"
             class="row"
        >
          <div [class.debt-size]="parseFloat(calcDebt.summa) <= 0" class="column account-left">
            <p>{{ parseFloat(calcDebt.summa) > 0 ? "Ваш борг:" : 'Ваш баланс:' }}</p>
          </div>
          <div [class.credit-size]="parseFloat(calcDebt.summa) <= 0" class="column account-right">
            <p class="credit-uah">{{ calcDebt.summaUAHAbs }} UAH</p>
            <p class="credit">{{ calcDebt.summaAbs }} EUR</p>
          </div>
        </div>
        <div *ngIf="calcDebt.summa_nalojki && (!activeOrganization || activeOrganization.type === 'fiz')"
             [class.account]="parseFloat(calcDebt.summa_nalojki) != 0"
             class="row"
        >
          <ng-container *ngIf="parseFloat(calcDebt.summa_nalojki) != 0">
            <div [class.debt-size]="parseFloat(calcDebt.summa_nalojki) <= 0" class="column account-left">
              <p>{{ parseFloat(calcDebt.summa_nalojki) > 0 ? 'Ваш борг по наложкам:' : 'Ваш баланс по наложкам:' }}</p>
            </div>
            <div [class.credit-size]="parseFloat(calcDebt.summa_nalojki) <= 0" class="column account-right">
              <p class="credit">{{ calcDebt.summaNalojkiAbs }} UAH</p>
            </div>
          </ng-container>
        </div>
      </a>
      <a class="pay-notify button inverse"
         (click)="showModalPayment()"
         *ngIf="has_cards && (parseFloat(calcDebt.summa) != 0 || ((!activeOrganization || activeOrganization.type === 'fiz') && parseFloat(calcDebt.summa_nalojki) != 0))"
      >
        Повідомити про оплату
      </a>
    </div>

    <div class="calculation-card-debt" *ngIf="activeOrganization && activeOrganization.type !== 'fiz' && buBalance !== null" (click)="openBuCalculations()">
      <div [class.account]="buBalance <= 0" class="row">
        <div [class.debt-size]="buBalance <= 0" class="column account-left">
          <p>{{ buBalance > 0 ? 'Ваш борг:' : 'Ваш баланс:' }}</p>
        </div>
        <div [class.credit-size]="buBalance <= 0" class="column account-right">
          <p class="credit-uah">{{ (buBalance < 0 ? buBalance * -1 : buBalance) | number:'1.2-2' }} UAH</p>
        </div>
      </div>
    </div>

    <div class="search-brand">
      <input
        [(ngModel)]="filterBrand"
        (input)="searchBrand(true)"
        type="text"
        placeholder="Знайти бренд">
      <label *ngIf="filterBrand === ''" class="search-icon"></label>
      <button type="button" *ngIf="filterBrand !== ''" class="cross-clears" (click)="crossClears()"></button>
    </div>

    <div class="brands-container">
      <div class="brands-menu" [class.single-brand]="foundArrayBrands.length === 1">
        <div class="brand-item"
             *ngFor="let brand of this.foundArrayBrands; let i = index"
             [class.selected-brand]="i === brandIndex"
             (click)="selectBrand(i)">
          {{ brand.name }}

          <button type="button"
                  class="brand-clear"
                  *ngIf="i === brandIndex"
                  (click)="crossClearBrand($event)">
          </button>
        </div>
      </div>

      <div class="border-line"></div>
    </div>

    <div class="list-cats">
      <div class="item-cat" *ngFor="let categories of foundArray; let i = index">
        <b class="head-menu" [class.selected-category]="i === categoryIndex"
           (click)="openCategoriesHead(i)">{{ categories.name }}</b>

        <div class="categories" *ngIf="i === categoryIndex || filterBrand !== '' || urlParams.brand_id > 0">
          <ng-container *ngIf="foundArray[i]">
            <ul *ngFor="let category of foundArray[i].values">
              <ng-container
                *ngTemplateOutlet="categoryBranch; context: {$implicit: category, path: [category], headIndex: i}"
              ></ng-container>
            </ul>
          </ng-container>
        </div>
      </div>

      <ng-container *ngIf="showCharacteristics">
        <div class="border-line"></div>

        <div class="item-cat characteristics-reset" *ngIf="hasSelectedCharacteristics">
          <a (click)="resetCharacteristics()">Скинути все</a>
        </div>

        <ng-container *ngFor="let section of characteristicSections; let i = index">
          <div class="item-cat" *ngIf="hasCharacteristicValues(section.key)">
            <div class="characteristic-head">
              <b class="head-menu"
                 [class.selected-category]="getSelectedCharacteristics(section.key).length"
                 (click)="openCharacteristicHead(section.key)">{{ section.name }}</b>
              <a class="characteristic-reset"
                 *ngIf="getSelectedCharacteristics(section.key).length"
                 (click)="resetCharacteristic(section.key)">Скинути</a>
            </div>

            <div class="categories" *ngIf="isCharacteristicOpen(section.key)">
              <ng-container *ngIf="section.key === 'approvals'; else flatSection">
                <div class="search-brand">
                  <input
                    [(ngModel)]="filterApproval"
                    (input)="searchApproval()"
                    type="text"
                    placeholder="Знайти допуск">
                  <label *ngIf="filterApproval === ''" class="search-icon"></label>
                  <button type="button" *ngIf="filterApproval !== ''" class="cross-clears" (click)="crossClearApproval()"></button>
                </div>

                <ul *ngFor="let group of visibleApprovalGroups">
                  <li>
                    <a class="has-child" (click)="openApprovalGroup(group)">
                      {{ group.name }} ({{ group.count }})
                    </a>
                    <ul class="has-child-hide" [class.has-child-show]="isApprovalGroupOpen(group)">
                      <li *ngFor="let item of group.values">
                        <label class="label-checkbox"
                               [class.active]="isCharacteristicSelected('approvals', item.value)"
                               (click)="toggleCharacteristic('approvals', item.value)">
                          {{ item.value }} ({{ item.count }})
                        </label>
                      </li>
                    </ul>
                  </li>
                </ul>

                <ul *ngIf="!approvalGroups.length">
                  <li>Нічого не знайдено</li>
                </ul>

                <ul *ngIf="hiddenApprovalGroupsCount > 0">
                  <li><a (click)="toggleShowAllApprovals()">Показати всі ({{ approvalGroups.length }})</a></li>
                </ul>

                <ul *ngIf="showAllApprovals && filterApproval === '' && approvalGroups.length > approvalGroupsLimit">
                  <li><a (click)="toggleShowAllApprovals()">Згорнути</a></li>
                </ul>
              </ng-container>

              <ng-template #flatSection>
                <ul>
                  <li *ngFor="let item of flatValues[section.key] | slice:0:(showAllFlat[section.key] ? undefined : flatValuesLimit)">
                    <label class="label-checkbox"
                           [class.active]="isCharacteristicSelected(section.key, item.value)"
                           (click)="toggleCharacteristic(section.key, item.value)">
                      {{ item.label || item.value }} ({{ item.count }})
                    </label>
                  </li>
                </ul>

                <ul *ngIf="!showAllFlat[section.key] && flatValues[section.key].length > flatValuesLimit">
                  <li><a (click)="toggleShowAllFlat(section.key)">Показати всі ({{ flatValues[section.key].length }})</a></li>
                </ul>

                <ul *ngIf="showAllFlat[section.key] && flatValues[section.key].length > flatValuesLimit">
                  <li><a (click)="toggleShowAllFlat(section.key)">Згорнути</a></li>
                </ul>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>


    <div class="categories-found"></div>
  </div>
</div>

<div class="dark-layer" [class.modal-favorites-show]="isDarkBackground" (click)="closeModal()"></div>

<app-modal-bu-calculations></app-modal-bu-calculations>

<!--
  Гілка дерева категорій: шаблон викликає сам себе, тому рівнів може бути скільки
  завгодно. Раніше розмітка була жорстко на три рівні (розділ -> бренд ->
  категорія), і 4-й рівень довідника в каталог не потрапляв.
  context.path — шлях від категорії другого рівня до вузла включно (хлібні крихти).
-->
<ng-template #categoryBranch let-category let-path="path" let-headIndex="headIndex">
  <li [class.size-category-child]="path.length > 1">
    <a [class.has-child]="category.values && category.values.length"
       [class.selected-sub-category]="category.id == urlParams.category_id"
       (click)="selectCategoryBranch(path, headIndex)"
    >
      {{ category.name }}
    </a>
    <ul class="has-child-hide"
        [class.has-child-show]="category.isOpenCategory"
        *ngIf="category.values && category.values.length"
    >
      <ng-container *ngFor="let child of category.values">
        <ng-container
          *ngTemplateOutlet="categoryBranch; context: {$implicit: child, path: childCategoryPath(path, child), headIndex: headIndex}"
        ></ng-container>
      </ng-container>
    </ul>
  </li>
</ng-template>
